// Inline SVG rendition of the RL monogram (public/rembo_logo.png), so it can be
// animated, recolored, and reused as a watermark instead of a static raster asset.

const LETTER_PATHS = [
  // R: stem, bowl, diagonal leg
  "M16 46 V18",
  "M16 18 H24 Q30 18 30 25 Q30 32 24 32 H16",
  "M20 32 L32 46",
  // L: stem (shares the baseline foot below)
  "M38 18 V46",
  // Shared baseline connecting both letters
  "M16 46 H46",
];

const VARIANT_PROPS = {
  solid: {
    circle: { fill: "var(--color-primary)", stroke: "none" },
    letters: "var(--color-bg-subtle)",
  },
  outline: {
    circle: { fill: "none", stroke: "var(--color-primary)", strokeWidth: 3 },
    letters: "var(--color-primary)",
  },
  mono: {
    circle: { fill: "none", stroke: "currentColor", strokeWidth: 3 },
    letters: "currentColor",
  },
};

export default function RemboMark({
  size = 48,
  variant = "solid",
  className,
  title,
  ...rest
}) {
  const cfg = VARIANT_PROPS[variant] || VARIANT_PROPS.solid;
  const accessibleProps = title
    ? { role: "img", "aria-label": title }
    : { "aria-hidden": true, focusable: "false" };

  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      {...accessibleProps}
      {...rest}
    >
      {title && <title>{title}</title>}
      <circle cx="32" cy="32" r="30" {...cfg.circle} />
      <g
        fill="none"
        stroke={cfg.letters}
        strokeWidth={6}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {LETTER_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
    </svg>
  );
}
